function createMailruPixel(counterId, counterType) {
  /* eslint-disable */
    var _tmr = window._tmr || (window._tmr = []);
    _tmr.push({id: counterId, type: counterType, start: (new Date()).getTime(), pid: "USER_ID"});

    (function (d, w, id) {
     if (d.getElementById(id)) return;
     var ts = d.createElement("script"); ts.type = "text/javascript"; ts.async = true; ts.id = id;
     ts.src = "https://top-fwz1.mail.ru/js/code.js";
     var f = function () {var s = d.getElementsByTagName("script")[0]; s.parentNode.insertBefore(ts, s);};
     if (w.opera == "[object Opera]") { d.addEventListener("DOMContentLoaded", f, false); } else { f(); }
    })(document, window, "topmailru-code");

    // for noscript
    var noscript = document.createElement('noscript');
    noscript.innerHTML = '<img src="//top-fwz1.mail.ru/counter?id=" + counterId + ";js=na" style="border:0;position:absolute;left:-9999px;" alt="" />';
    document.body.appendChild(noscript);
    /* eslint-enable */
}

module.exports = createMailruPixel;
